<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Usuario">
          <b-form>
            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                :value="email"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Apellido"
              label-for="apellido"
              :label-cols="labelCols">
              <b-form-input 
                id="apellido"
                class="text-upper"
                v-model.trim= "$v.apellido.$model" 
                :state="apellidoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="apellidoFeedback">
                {{ apellidoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols">
              <b-form-input 
                id="nombre"
                class="text-upper"
                v-model.trim= "$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'usuarioPerfil/getField',
  mutationType: 'usuarioPerfil/updateField',
});

export default {
  name: 'Perfil',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      noValidar: true,
      apellidoValido: null,
      apellidoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'id',
      'email',
      'apellido',
      'nombre',
      'admin',
    ])
  },  
  created() {
    this.showSpinner();
    this.$store.dispatch('usuarioPerfil/inicializar')
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
            this.$v.$touch();
          
          this.displayErrores(event.target.id);
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'apellido' || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false;
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj = 'Debe ingresar el apellido del usuario';
          } else if (!this.$v.apellido.maxLength) {
            this.apellidoInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del usuario';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('usuarioPerfil/save')
          .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goBack, this.goBack, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  watch: {
  },
  validations: {
    apellido: {
      required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
